<div
	*ngIf="editMode"
	class="overlay bg-black opacity-30 fixed top-0 left-0 w-screen h-screen z-30"
></div>

<div
	class="flex flex-row justify-between mt-4 min-h-[40px]"
	(click)="changeEditMode()"
>
	<p class="text-main-color-black text-font-16 font-medium text-base mb-[29px]">
		{{ 'ORGANIZATION.BRANCH.SETTINGS' | translate }}
	</p>
	<div
		*ngIf="!editMode"
		class="flex gap-1 ltr:mr-6 rtl:ml-6 hover:cursor-pointer"
	>
		<img class="w-5 max-h-5" src="assets/images/edit-blue.svg" alt="" />
		<p class="text-blue-link">{{ 'ACTIONS.EDIT' | translate }}</p>
	</div>
</div>
<div
	class="custom-shadow p-24px rounded-12px bg-off-white lg:w-[776px] {{
		editMode ? 'z-40' : ''
	}} relative"
>
	<form [formGroup]="settingsForm" class="w-[100%]">
		<div class="flex justify-between mb-[32px]">
			<div class="w-2/4 mr-24px">
				<h1
					class="text-font-16 ltr:font-DIN-Bold font-bold rtl:font-medium text-disabled-btn-txt-Color mb-12px"
				>
					{{ 'ORGANIZATION.BRANCH_SETTINGS.RESERVATION_PER_DAY' | translate }}
				</h1>
				<p class="text-font-14 text-medium-gray mb-0">
					{{
						'ORGANIZATION.BRANCH_SETTINGS.NUMBER_RESERVATION_PER_DAY'
							| translate
					}}
				</p>
			</div>
			<div class="w-2/4">
				<mat-form-field
					class="w-full mb-46px"
					[hideRequiredMarker]="false"
					appearance="outline"
				>
					<input
						maxlength="3"
						(keypress)="isNumber($event)"
						formControlName="reservationPerDay"
						class="text-dark-grey"
						type="text"
						matInput
						required
					/>
					<img
						*ngIf="editMode"
						class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
						src="./assets/images/close-square.svg"
						alt=""
						(click)="getController('reservationPerDay').setValue('')"
					/>
				</mat-form-field>
				<mat-error>
					<validation-message
						[controller]="getController('reservationPerDay')"
						controller_name="{{
							'GENERAL_LABELS.RESERVATION_PER_DAY' | translate
						}}"
						pattern_Message=""
					>
					</validation-message>
					<p
						*ngIf="
							getController('reservationPerDay').value <
								reservationPerDayOldNumber &&
							getController('reservationPerDay').value !== '' &&
							editMode
						"
					>
						{{ 'ORGANIZATION.BRANCH_SETTINGS.NEW_MAX' | translate }}
					</p>
				</mat-error>
			</div>
		</div>

		<div class="flex justify-between">
			<div class="w-2/4 mr-24px">
				<h1 class="text-font-16 text-dark-grey mb-12px">
					{{
						'ORGANIZATION.BRANCH_SETTINGS.RESERVATIONS_PER_TIMESLOT' | translate
					}}
				</h1>
				<p class="text-font-14 text-medium-gray mb-0">
					{{
						'ORGANIZATION.BRANCH_SETTINGS.NUMBER_RESERVATIONS_PER_TIMESLOT'
							| translate
					}}
				</p>
			</div>
			<div class="w-2/4">
				<mat-form-field class="w-full mb-[8px]" appearance="outline">
					<input
						(keypress)="isNumber($event)"
						maxlength="3"
						formControlName="reservationPerTimeSlot"
						class="text-dark-grey"
						type="text"
						matInput
						required
					/>
					<img
						*ngIf="editMode"
						class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
						src="./assets/images/close-square.svg"
						alt=""
						(click)="getController('reservationPerTimeSlot').setValue('')"
					/>
				</mat-form-field>
				<mat-error>
					<validation-message
						[controller]="getController('reservationPerTimeSlot')"
						controller_name="{{
							'GENERAL_LABELS.RESERVATION_PER_TIMESLOT' | translate
						}}"
						pattern_Message=""
					>
					</validation-message>
					<p
						*ngIf="
							getController('reservationPerTimeSlot').value <
								reservationPerTimeSlotOldNumber &&
							getController('reservationPerTimeSlot').value !== '' &&
							editMode
						"
					>
						{{ 'ORGANIZATION.BRANCH_SETTINGS.NEW_MAX' | translate }}
					</p>
				</mat-error>
			</div>
		</div>
	</form>

	<div class="flex mt-24px justify-end" *ngIf="editMode">
		<button
			(click)="changeEditMode(); cancelAction()"
			class="border border-solid border-[#D9DBE9] text-dark-grey hover:bg-gradient hover:text-off-white mx-2"
			mat-button
		>
			{{ 'ACTIONS.CANCEL' | translate }}
		</button>
		<button
			[disabled]="checkDisabled()"
			(click)="saveAction()"
			class="bg-gradient text-off-white rounded"
			mat-button
		>
			{{ 'ACTIONS.SAVE' | translate }}
		</button>
	</div>
</div>
